import { ICONS } from "../components/general-ui/icon";

export const socialOptions = [
	{
		label: "Facebook",
		value: ICONS.FACEBOOK
	},
	{
		label: "Twitter",
		value: ICONS.TWITTER
	},
	{
		label: "LinkedIn",
		value: ICONS.LINKEDIN
	},
	{
		label: "Instagram",
		value: ICONS.INSTAGRAM
	},
	{
		label: "YouTube",
		value: ICONS.YOUTUBE
	},
	{
		label: "Website",
		value: ICONS.WEBSITE
	}
];